import styled, { css } from 'styled-components';
import { FlexBox } from '@brg/ui';
import Select, { components } from 'react-select';
import { ValueContainer } from './DropdownEditable';

export interface CustomInputProps {
    customBorderColor?: string;
    customBorderColorHover?: string;
    customTextColor?: string;
    customPlaceholderColor?: string;
    customBackgroundColor?: string;
    customBackgroundColorHover?: string;
    customHeight?:string;
    customScrollColor?: string;
    customShadow?: string;
    customOptionBackgroundColorHover?: string;
    customOptionTextColorHover?: string;
}

export interface DropdownProps {
    [name: string]: any;
    custom?: CustomInputProps;
}

export const AutoMenuStyle = css<CustomInputProps>`
    color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
`;

export const DropdownWrapper = styled(FlexBox)<CustomInputProps>`
    .widthWrapper {
        width: 100%;
    }
    flex: 1;
    width: 100%;
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // INPUT DISABLED SECTION
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    /* ______________________________________________ */
   
    .brg-input--is-disabled {
        color: rgba(254, 254, 254, 0.31) !important;
        .brg-input__control {
            /* color: rgba(254, 254, 254, 0.31) !important; */
            color: ${(p) => p.theme.dropdown.textColor};
            background-color: ${(p) => p.customBackgroundColor ?? p.theme.dropdown.bgColor};
            border-color: ${(p) => p.theme.dropdown.borderColor};
        }

        .brg-input__single-value,
        .brg-input__input {
            /* color: rgba(254, 254, 254, 0.31) !important; */
            color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
        }
    }

    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // INDICATOR SECTION
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    .brg-input__indicator {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 1px;
        opacity: 0.47;
        transition: opacity 0.2s, transform 0.2s;
        svg {
            fill: ${(p) => p.customTextColor ?? p.theme.dropdown.arrow};
        }
    }

    .brg-input__control--menu-is-open {
        .brg-input__indicator {
            transform: rotate(180deg);
        }
    }

    .brg-autofill {
        width: 100%;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .brg-input__indicator-separator {
        display: none;
    }

    //
    // CONTROL FRAME PLACEHOLDER
    //
    .brg-input__placeholder {
        ${AutoMenuStyle};
        transition: color 0.2s;
        opacity: 0.7;
    }

    .brg-input__input {
        ${AutoMenuStyle};
        color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
    }

    //
    // CONTROL FRAME DEFAULT STATE
    //
    .brg-input__control {
        outline: none !important;
        box-shadow: none !important;
        border-color: ${(p) => p.customBorderColor ?? p.theme.dropdown.borderColor};
        /* background-color: #30363a; */
        background-color: ${(p) => p.customBackgroundColor ?? p.theme.dropdown.bgColor};
        color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
        height: ${p => p.customHeight ? p.customHeight : '48px !important'};
        transition: border 0.2s;
        border-radius: 3px !important;
        cursor: pointer;
        flex: 1;
        &:hover {
            border-color: ${(p) => p.customBorderColorHover ?? '#30363a'};

            .brg-input__indicator {
                opacity: 1;
            }
            .brg-input__single-value {
                opacity: 1;
            }

            .brg-input__placeholder {
                /* color: rgba(254, 254, 254, 0.47); */
                /* color: #151514 !important; */
                color: ${(p) => p.customPlaceholderColor ?? p.theme.dropdown.textColor};
                opacity: 1;
            }
        }
      
      ${(p) => p.customBorderColor === 'transparent' && css`
        border: none!important;
      `};

    }

    .brg-input__value-container {
        padding: 0 16px;
    }

    //
    // CONTROL FRAME WHEN FOCUS
    //
    .brg-input__control--is-focused {
        border-color: ${(p) => p.customBorderColorHover ?? p.theme.dropdown.borderFocusColor} !important;
        &:hover {
            border-color: rgba(255, 255, 255, 0.31);
        }
        .brg-input__indicator {
            opacity: 1;
        }
    }

    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // MENU SECTION
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

    .brg-input__menu {
        ${AutoMenuStyle};
        color: ${(p) => p.customTextColor ?? '#151515'} !important;
        margin: 0;
        background: ${(p) => p.customBackgroundColor ?? p.theme.dropdown.bgColor};
        border: ${(p) => p.customBorderColorHover === 'transparent' ? 'none' : ('1px solid ' + (p.customBorderColorHover ?? p.theme.dropdown.borderFocusColor))} !important;
        box-shadow: ${(p) => p.customShadow ?? '0 1px 4px rgba(7, 7, 7, 0.17)'};
        border-radius: ${(p) => p.customShadow ? '0 0 3px 3px' : '3px'};
        z-index: 15;
    }

    .brg-input__menu-list {
        position: relative;
        padding: 0;

      ::-webkit-scrollbar {
        width: 3px; /* ширина scrollbar */
        height: 10px;
      }
      ::-webkit-scrollbar-track {
        background: ${(p) => p.customBackgroundColorHover ?? p.theme.dropdown.bgColorHover};
      }
      ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: ${(p) => p.customScrollColor ?? p.theme.dropdown.scrollColor};
      }
    }

    .brg-input__option {
        ${AutoMenuStyle};
        height: 48px !important;
        display: flex;
        align-items: center;
        cursor: pointer;
        svg {
            fill: ${(p) => p.customTextColor ?? p.theme.dropdown.arrow};
        }

        &:hover {
            color: ${(p) => p.customOptionTextColorHover ?? p.theme.dropdown.arrow};
            background: ${(p) => p.customOptionBackgroundColorHover ?? p.theme.dropdown.bgColorHover} !important;
        }
    }

    .brg-input__option--is-focused {
        background: ${(p) => p.customBackgroundColorHover ?? p.theme.dropdown.bgColorHover} !important;
    }

    .brg-input__option--is-selected {
        background: none;
    }

    .brg-input__menu-notice {
        font-family: Inter, sans-serif;
        height: 48px !important;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 16px;
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 13px;
        letter-spacing: 0.06em;
        color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
    }

    .brg-input__menu-notice--no-options {
    }

    .brg-input__single-value {
        ${AutoMenuStyle};
        color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
        //opacity: 0.7;
    }
`;

export const OptionIcon = styled.div`
    display: flex;
    margin-left: auto;
    margin-right: 4px;
`;

const OptionColor = styled.div<{ color: string }>`
    background: ${(p) => p.color};
    height: 46px;
    width: 4px;
    position: absolute;
    left: 0;
    top: -1px;
`;

export const Option = (props: any) => (
    <components.Option {...props}>
        {props && props.data.color && <OptionColor color={props.data.color} />}
        {props.children}
        {props.isSelected && (
            <OptionIcon>
                <svg width="11" height="8" viewBox="0 0 11 8" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.406428 4.07812L4.02859 7.67898L10.6763 1.05256L9.84535 0.22159L4.02859 6.01705L1.21609 3.24716L0.406428 4.07812Z" />
                </svg>
            </OptionIcon>
        )}
    </components.Option>
);

function Indicator(p: any) {
    return (
        <components.DropdownIndicator {...p}>
            <svg width="14" height="8" viewBox="0 0 14 8" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.64575 7.64588L0.636039 1.63617L1.34432 0.927891L6.99991 6.58349L12.6557 0.927918L13.3639 1.63618L7.35401 7.64587L6.99987 8L6.64575 7.64588Z"
                />
            </svg>
        </components.DropdownIndicator>
    );
}

function Menu(p: any) {
    return (
        <components.Menu {...p}>
            {p.children}
        </components.Menu>
    );
}

export const Dropdown = (props: DropdownProps) => (
  <DropdownWrapper {...props.custom}>
    <div className="widthWrapper">
      <Select
        components={{
          DropdownIndicator: Indicator,
          Menu: Menu,
          Option,
          ValueContainer,
        }}
        cacheOptions
        maxMenuHeight={172}
        className={'brg-autofill'}
        classNamePrefix={'brg-input'}
        noOptionsMessage={() => 'No such position'}
        isSearchable={false}
        isClearable={false}
        {...props}
      />
    </div>
  </DropdownWrapper>
);
import styled, { css } from 'styled-components';
import { FlexBox } from '@brg/ui';
import Select, { components } from 'react-select';
import { ValueContainer } from './DropdownEditable';

export interface CustomInputProps {
    customBorderColor?: string;
    customBorderColorHover?: string;
    customTextColor?: string;
    customPlaceholderColor?: string;
    customBackgroundColor?: string;
    customBackgroundColorHover?: string;
    customHeight?:string;
    customScrollColor?: string;
    customShadow?: string;
    customOptionBackgroundColorHover?: string;
    customOptionTextColorHover?: string;
}

export interface DropdownProps {
    [name: string]: any;
    custom?: CustomInputProps;
}

export const AutoMenuStyle = css<CustomInputProps>`
    color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
`;

export const DropdownWrapper = styled(FlexBox)<CustomInputProps>`
    .widthWrapper {
        width: 100%;
    }
    flex: 1;
    width: 100%;
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // INPUT DISABLED SECTION
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    /* ______________________________________________ */
   
    .brg-input--is-disabled {
        color: rgba(254, 254, 254, 0.31) !important;
        .brg-input__control {
            /* color: rgba(254, 254, 254, 0.31) !important; */
            color: ${(p) => p.theme.dropdown.textColor};
            background-color: ${(p) => p.customBackgroundColor ?? p.theme.dropdown.bgColor};
            border-color: ${(p) => p.theme.dropdown.borderColor};
        }

        .brg-input__single-value,
        .brg-input__input {
            /* color: rgba(254, 254, 254, 0.31) !important; */
            color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
        }
    }

    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // INDICATOR SECTION
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    .brg-input__indicator {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 1px;
        opacity: 0.47;
        transition: opacity 0.2s, transform 0.2s;
        svg {
            fill: ${(p) => p.customTextColor ?? p.theme.dropdown.arrow};
        }
    }

    .brg-input__control--menu-is-open {
        .brg-input__indicator {
            transform: rotate(180deg);
        }
    }

    .brg-autofill {
        width: 100%;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .brg-input__indicator-separator {
        display: none;
    }

    //
    // CONTROL FRAME PLACEHOLDER
    //
    .brg-input__placeholder {
        ${AutoMenuStyle};
        transition: color 0.2s;
        opacity: 0.7;
    }

    .brg-input__input {
        ${AutoMenuStyle};
        color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
    }

    //
    // CONTROL FRAME DEFAULT STATE
    //
    .brg-input__control {
        outline: none !important;
        box-shadow: none !important;
        border-color: ${(p) => p.customBorderColor ?? p.theme.dropdown.borderColor};
        /* background-color: #30363a; */
        background-color: ${(p) => p.customBackgroundColor ?? p.theme.dropdown.bgColor};
        color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
        height: ${p => p.customHeight ? p.customHeight : '48px !important'};
        transition: border 0.2s;
        border-radius: 3px !important;
        cursor: pointer;
        flex: 1;
        &:hover {
            border-color: ${(p) => p.customBorderColorHover ?? '#30363a'};

            .brg-input__indicator {
                opacity: 1;
            }
            .brg-input__single-value {
                opacity: 1;
            }

            .brg-input__placeholder {
                /* color: rgba(254, 254, 254, 0.47); */
                /* color: #151514 !important; */
                color: ${(p) => p.customPlaceholderColor ?? p.theme.dropdown.textColor};
                opacity: 1;
            }
        }
      
      ${(p) => p.customBorderColor === 'transparent' && css`
        border: none!important;
      `};

    }

    .brg-input__value-container {
        padding: 0 16px;
    }

    //
    // CONTROL FRAME WHEN FOCUS
    //
    .brg-input__control--is-focused {
        border-color: ${(p) => p.customBorderColorHover ?? p.theme.dropdown.borderFocusColor} !important;
        &:hover {
            border-color: rgba(255, 255, 255, 0.31);
        }
        .brg-input__indicator {
            opacity: 1;
        }
    }

    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // MENU SECTION
    // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

    .brg-input__menu {
        ${AutoMenuStyle};
        color: ${(p) => p.customTextColor ?? '#151515'} !important;
        margin: 0;
        background: ${(p) => p.customBackgroundColor ?? p.theme.dropdown.bgColor};
        border: ${(p) => p.customBorderColorHover === 'transparent' ? 'none' : ('1px solid ' + (p.customBorderColorHover ?? p.theme.dropdown.borderFocusColor))} !important;
        box-shadow: ${(p) => p.customShadow ?? '0 1px 4px rgba(7, 7, 7, 0.17)'};
        border-radius: ${(p) => p.customShadow ? '0 0 3px 3px' : '3px'};
        z-index: 15;
    }

    .brg-input__menu-list {
        position: relative;
        padding: 0;

      ::-webkit-scrollbar {
        width: 3px; /* ширина scrollbar */
        height: 10px;
      }
      ::-webkit-scrollbar-track {
        background: ${(p) => p.customBackgroundColorHover ?? p.theme.dropdown.bgColorHover};
      }
      ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: ${(p) => p.customScrollColor ?? p.theme.dropdown.scrollColor};
      }
    }

    .brg-input__option {
        ${AutoMenuStyle};
        height: 48px !important;
        display: flex;
        align-items: center;
        cursor: pointer;
        svg {
            fill: ${(p) => p.customTextColor ?? p.theme.dropdown.arrow};
        }

        &:hover {
            color: ${(p) => p.customOptionTextColorHover ?? p.theme.dropdown.arrow};
            background: ${(p) => p.customOptionBackgroundColorHover ?? p.theme.dropdown.bgColorHover} !important;
        }
    }

    .brg-input__option--is-focused {
        background: ${(p) => p.customBackgroundColorHover ?? p.theme.dropdown.bgColorHover} !important;
    }

    .brg-input__option--is-selected {
        background: none;
    }

    .brg-input__menu-notice {
        font-family: Inter, sans-serif;
        height: 48px !important;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 16px;
        font-style: normal;
        font-weight: 500;
        font-size: 10px;
        line-height: 13px;
        letter-spacing: 0.06em;
        color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
    }

    .brg-input__menu-notice--no-options {
    }

    .brg-input__single-value {
        ${AutoMenuStyle};
        color: ${(p) => p.customTextColor ?? p.theme.dropdown.textColor};
        //opacity: 0.7;
    }
`;

export const OptionIcon = styled.div`
    display: flex;
    margin-left: auto;
    margin-right: 4px;
`;

const OptionColor = styled.div<{ color: string }>`
    background: ${(p) => p.color};
    height: 46px;
    width: 4px;
    position: absolute;
    left: 0;
    top: -1px;
`;

export const Option = (props: any) => (
    <components.Option {...props}>
        {props && props.data.color && <OptionColor color={props.data.color} />}
        {props.children}
        {props.isSelected && (
            <OptionIcon>
                <svg width="11" height="8" viewBox="0 0 11 8" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.406428 4.07812L4.02859 7.67898L10.6763 1.05256L9.84535 0.22159L4.02859 6.01705L1.21609 3.24716L0.406428 4.07812Z" />
                </svg>
            </OptionIcon>
        )}
    </components.Option>
);

function Indicator(p: any) {
    return (
        <components.DropdownIndicator {...p}>
            <svg width="14" height="8" viewBox="0 0 14 8" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.64575 7.64588L0.636039 1.63617L1.34432 0.927891L6.99991 6.58349L12.6557 0.927918L13.3639 1.63618L7.35401 7.64587L6.99987 8L6.64575 7.64588Z"
                />
            </svg>
        </components.DropdownIndicator>
    );
}

function Menu(p: any) {
    return (
        <components.Menu {...p}>
            {p.children}
        </components.Menu>
    );
}

export const Dropdown = (props: DropdownProps) => (
  <DropdownWrapper {...props.custom}>
    <div className="widthWrapper">
      <Select
        components={{
          DropdownIndicator: Indicator,
          Menu: Menu,
          Option,
          ValueContainer,
        }}
        cacheOptions
        maxMenuHeight={172}
        className={'brg-autofill'}
        classNamePrefix={'brg-input'}
        noOptionsMessage={() => 'No such position'}
        isSearchable={false}
        isClearable={false}
        {...props}
      />
    </div>
  </DropdownWrapper>
);
